// extracted by mini-css-extract-plugin
export default {"placeholder":"imagePicker_placeholder__pZHTr","error":"imagePicker_error__XMzLk"};